<template>
  <div>
    <Edit @exit="() => { editData = null; editDialog = false }" :edit-data="editData" :dialog="editDialog"></Edit>
    <v-dialog width="500" v-model="createDialog">
      <template slot="activator">
        <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.new_team')">
          <v-btn block color="primary" v-on="on">
            <v-icon>group_add</v-icon>
          </v-btn>
        </Tooltip>
      </template>
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('team.create.title') }}
        </v-card-title>
        <create-form @exit="createDialog = false"></create-form>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="teams"
      :loading="loading"
      :rows-per-page-text="tableTranslations.rowsPerPageText"
      :no-data-text="tableTranslations.noDataText"
      :no-results-text="tableTranslations.noResultsText"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-1">
      <v-progress-linear slot="progress" color="primary" indeterminate ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-right">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.membersAmount }}</td>
        <td class="text-xs-left">{{ props.item.schemasAmount }}</td>
        <td>
          <v-layout align-center row fill-height>
            <v-flex xs6>
              <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.delete')">
                <v-btn block color="warning" v-on="on" v-on:click="removeTeam(props)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </Tooltip>
            </v-flex>
            <v-flex xs6>
              <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.edit')">
                <v-btn block color="primary" v-on="on" v-on:click="()=>{ editData = props.item; editDialog = true }">
                  <v-icon>edit</v-icon>
                </v-btn>
              </Tooltip>
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CreateForm from "./dialogs/CreateForm"
import Edit from "@/components/team/dialogs/Edit"
import Tooltip from "@/components/common/Tooltip.vue"

export default {
  components: {
    CreateForm,
    Edit,
    Tooltip
  },
  data() {
    return {
      editData: null,
      editDialog: false,
      pagination: this.$store.getters.pagination,
      headers: [
        {
          text: this.$t('base.id'),
          value: 'id',
          align: 'right'
        },
        {
          text: this.$t('team.name'),
          value: 'name',
          width: '25%',
        },
        {
          text: this.$t('team.list.members-amount'),
          value: 'membersAmount'
        },
        {
          text: this.$t('team.list.schemas-amount'),
          value: 'schemasAmount'
        },
        {
          text: this.$t('team.list.deleting')
        }
      ],
      loading: false,
      createDialog: false
    }
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    teams() {
      return this.$store.state.teams
    }
  },
  mounted() {
    this.loadTeams()
  },
  methods: {
    loadTeams() {
      this.loading = true
      this.$store.dispatch("loadTeams").then(() => {
        this.loading = false
      })
    },
    removeTeam({ item, index }) {
      this.$confirm(this.$t('team.list.delete-confirmation', { "team-name": item.name }))
          .then(res => {
            if (res) {
              this.loading = true
              this.$store.dispatch("removeTeam", {
                id: item.id,
                index
              }).finally(() => {
                this.loading = false
              })
            }
          })
    }
  },
}
</script>

<style scoped>
th {
  text-transform: capitalize;
}
</style>
